import Month from './Month.jsx'

export default Month
